import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () => {
  return axios.create({
    baseURL: `${config.serverUrl}`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })
}

const ticketApi = {
  getTicketTags: (request) => {
    return instance().get(`/tickets-tags`, { params: request })
  },
  getTicketTagsList: (pageId, params) => {
    return instance().get(`/page/${pageId}/ticket-tag-list`, { params })
  },
  putEditTicketTag: (request) => {
    const { data } = request
    const { pageid, ...rest } = data
    return instance().put(`page/${pageid}/edit-ticket-tag`, rest)
  },
  getExportTicket: (request) => {
    const { config } = request
    return instance().get(`/api/ticket/export-ticket`, config)
  },
  deleteTag: (request) => {
    const { data, pageid } = request

    return instance().delete(`page/${pageid}/delete-ticket-tag`, { data })
  },
  getSatisfactionSurvey: (params) => {
    return instance().get(`api/ticket/cms/satisfaction-survey`, { params })
  },
  getSatisfactionSurveyAgent: (params) => {
    return instance().get(`api/ticket/cms/satisfaction-survey/agent`, { params })
  },
  getAdminCheckInCheckOut: (request) => {
    const { params } = request
    return instance().get(`/api/ticket/cms/admin/check-in-out/history`, { params })
  },
  postAdminCheckIn: (request) => {
    const { data } = request
    return instance().post(`/api/ticket/cms/admin/check-in`, data)
  },
  postAdminCheckOut: (request) => {
    const { data } = request
    return instance().post(`/api/ticket/cms/admin/check-out`, data)
  },
  getTicketWithReasonLevel: (request) => {
    const { config } = request
    return instance().get(`/api/ticket/cms/reason/level`, config)
  }
}

export default ticketApi



// WEBPACK FOOTER //
// ./src/api/ticket.js